export function mapInterval(value, x1, y1, x2, y2) {
  return ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;
}

export function getAngle(n, k) {
  return (Math.PI * 2) / (k / n);
}

export function getPositionInCircle(n, k, r) {
  const angle = getAngle(n, k);
  return { x: Math.cos(angle) * r, y: Math.sin(angle) * r };
}
